import React from "react";
import { DateFormat } from "../../helpers/utils";
import TableBase from "./Base";

const SpinTheWheelReportsTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Winner Email",
			dataIndex: "winner_email",
			width: 200,
			ellipsis: true,
		},
		{
			title: "Reward",
			width: 200,
			ellipsis: true,
			render(record) {
				return <span>{record.reward && record.reward.name}</span>;
			},
		},
		{
			title: "Redeem Status",
			dataIndex: "redeem_status",
			width: 150,
			ellipsis: true,
			render(value) {
				return <span className={`table-status ${value}`}>{value}</span>;
			},
		},
		{
			title: "Date",
			dataIndex: "created_at",
			width: 100,
			ellipsis: true,
			render(value) {
				return DateFormat(value);
			},
		},
		{
			title: "Store ID",
			width: 100,
			ellipsis: true,
			render(record) {
				return (
					<span className="text-uppercase">
						{record.redeem && record.redeem.store_id}
					</span>
				);
			},
		},
		{
			title: "Staff ID",
			width: 100,
			ellipsis: true,
			render(record) {
				return (
					<span className="text-uppercase">
						{record.redeem && record.redeem.staff_id}
					</span>
				);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 50,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default SpinTheWheelReportsTable;
